<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">
                            <b>Procedimentos do Contrato</b>
                        </h3>

                        <router-link tag="a" class="btn btn-primary pull-right" :to="`/administracao/contratos/procedimentos/novo/${$route.params.contrato_id}`"><i class="fa fa-plus"></i> Adicionar Procedimento</router-link>
                    </div>

                    <div class="box-body">
                        <cabecario-contrato :contratoId="$route.params.contrato_id"></cabecario-contrato>
                        <filtro-contrato-procedimento
                            @filtrar="
                                filtros => {
                                    filtrar(filtros);
                                }
                            "
                        ></filtro-contrato-procedimento>

                        <div class="row" style="margin-top:15px">
                            <div class="col-sm-12 table-responsive">
                                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped">
                                    <thead>
                                        <tr role="row">
                                            <th style="width: 10%;">ID
												<!-- <span @click="sortByKey('procedimentos.codigo')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'procedimentos.codigo' ? `fa fa-sort-numeric${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span> -->
											</th>
                                            <th style="width: 30%;">
                                                Procedimento
                                                <span @click="sortByKey('procedimentos.nome')" class="icon-ordenacao">
                                                    <i :class="filtros.ordem && filtros.coluna == 'procedimentos.nome' ? `fa fa-sort-alpha${'-' + filtros.ordem}` : 'fa fa-sort'"></i>
                                                </span>
                                            </th>
                                            <th style="width: 10%;">Valor</th>
                                            <th style="width: 15%;">Tipo de Limite</th>
                                            <th style="width: 10%;">Limite Físico</th>
                                            <th style="width: 15%;">Valor Total</th>
                                            <th style="width: 10%">Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="even" role="row" v-for="item in dataTable.data" :key="item.id">
                                            <td>{{ item.codigo }}</td>
                                            <td>{{ item.nome }}</td>
                                            <td>{{ item.valor | numberFormat(2, ",", ".") }}</td>
                                            <td>{{ item.tipo_limite | tipo_limite }}</td>
                                            <td>{{ item.tipo_limite > 0 ? "Não Possui" : item.quantidade }}</td>
                                            <td>
                                                <span v-if="item.tipo_limite == 0">{{ (item.quantidade * item.valor) | numberFormat(2, ",", ".") }}</span>
                                                <span v-if="item.tipo_limite == 1">No Subgrupo</span>
                                                <span v-if="item.tipo_limite == 2">Não Possui</span>
                                            </td>
                                            <td>
                                                <router-link tag="button" class="btn btn-warning btn-sm" :to="`/administracao/contratos/procedimentos/atualizacao/${item.id}`" title=" Editar">
                                                    <i style="font-size:12px" class="fa fa-fw fa-edit"></i>
                                                </router-link>
                                                <button class="btn btn-danger btn-sm" title="Excluir" @click="deletar(item)">
                                                    <i style="font-size:12px" class="fa fa-fw fa-close"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-sm-5">Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>

                                    <div class="col-sm-7" style="text-align:right">
                                        <laravue-pagination :data="dataTable" v-on:pagination-change-page="getDataTable">
                                            <span slot="prev-nav">&lt; Anterior</span>
                                            <span slot="next-nav">Próximo &gt;</span>
                                        </laravue-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box-footer">
                        <div class="row">
                            <div class="col-md-12">
                                <button class="btn btn-default pull-left" @click="$router.go(-1)"><i class="fa fa-reply"></i> Voltar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import Alert from "../../Alert"; // Importando componente alert
import CabecarioContrato from "./cabecarioContrato";
import FiltroContratoProcedimento from "./filtroContratoProcedimento";

export default {
    filters: {
        tipo_limite: function(val) {
            if (val == 0) {
                return "Procedimento";
            } else if (val == 1) {
                return "Subgrupo";
            } else if (val == 2) {
                return "Geral";
            }
        }
    },
    data: () => ({
        filtros: {
            contrato_id: null,
            ordem: null,
            coluna: null
        },

        dataTable: {}
    }),

    mounted() {
        this.filtros.contrato_id = this.$route.params.contrato_id;
        this.getDataTable();
    },

    methods: {
        sortByKey: function(field) {
            this.filtros.coluna = field;
            if (this.filtros.ordem == "asc") {
                this.filtros.ordem = "desc";
            } else {
                this.filtros.ordem = "asc";
            }
            this.getDataTable();
        },

        filtrar: function(filtros) {
            this.filtros = { ...this.filtros, ...filtros };
            this.getDataTable();
        },

        getDataTable(page) {
            if (typeof page === "undefined") {
                page = 1;
            }

            this.filtros.page = page;
            this.$store.commit("TOGGLE_LOADING");

            let config = this.$store.getters.getHeaderAuth;
            config.params = this.filtros;

            axios
                .get(`${this.$store.state.serverURI}/api/administracao/contratos/getContratoProcedimentosPaginateOrdenado`, config)
                .then(response => {
                    this.dataTable = response.data;
                    this.$store.commit("TOGGLE_LOADING");
                })
                .catch(error => {
                    this.$store.commit("throwException", error);
                });
        },

        deletar(item) {
            this.$swal({
                title: `Confirma exclusão do procedimento ${item.nome}?`,
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
                cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
                reverseButtons: true
            }).then(result => {
                if (result.value) {
                    this.$swal({
                        title: "Aguarde...",
                        imageUrl: "/static/img/Rolling-green.gif",
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });
                    axios
                        .delete(`${this.$store.state.serverURI}/api/administracao/contratos/deleteContratoProcedimento/${item.id}`, this.$store.getters.getHeaderAuth)
                        .then(response => {
                            this.getDataTable();
                            this.$swal({
                                type: "success",
                                title: "Procedimento excluído com sucesso!",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            });
        }
    },
    watch: {
        page: function(val) {
            this.getDataTable();
        }
    },

    components: {
        Alert,
        CabecarioContrato,
        FiltroContratoProcedimento
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// contratoProcedimento.vue?11196f12